<template>
  <div>
    <component-header
      title="Approval Details"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/approvals')"
    />
    <b-card>
      <div>
        <h4 style="text-align: right">
          Status :
          <span
            class="span-text"
            v-if="currentUser.status == 'APPROVED'"
            style="color: green; font-weight: 800"
            >{{ currentUser.status }}</span
          >
          <span
            class="span-text"
            v-if="currentUser.status == 'REJECTED'"
            style="color: red; font-weight: 800"
            >{{ currentUser.status }}</span
          >
          <span
            class="span-text"
            v-if="currentUser.status == 'PENDING'"
            style="color: blue; font-weight: 800"
            >{{ currentUser.status }}</span
          >
        </h4>
      </div>
      <div>
        <h4
          class="mx-3"
          v-if="currentUser.approvalType == 'AGENT_ACTIVATION'"
          style="color: #727cf5"
        >
          Agent Details
        </h4>
        <h4
          class="mx-3"
          v-if="
            currentUser.approvalType === 'SUBSCRIPTION_ACTIVATION' ||
            currentUser.approvalType === 'PROVIDER_ACTIVATION'
          "
          style="color: #727cf5"
        >
          Provider Details
        </h4>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Name :
                <span class="span-text">{{
                  currentUser.provider && currentUser.provider.organization
                    ? currentUser.provider.organization.name
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                User Name :
                <span class="span-text">{{
                  currentUser.provider && currentUser.provider.organization
                    ? currentUser.provider.organization.userName
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text" v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
                DOB :
                <span class="span-text">{{ agentDetails.dob }}</span>
              </h5>

              <h5 class="h5-text" v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
                Marital Status :
                <span class="span-text">{{ agentDetails.maritalStatus }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Phone Number :
                <span class="span-text">{{ currentUser.provider.phone }}</span>
              </h5>
              <h5 class="h5-text" v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
                Working Experience :
                <span class="span-text"
                  >{{ agentDetails.experience ? agentDetails.experience.value : "" }}
                  {{ agentDetails.experience ? agentDetails.experience.uom : "" }}
                </span>
              </h5>
              <h5 class="h5-text" v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
                Education : <span class="span-text">{{ agentDetails.education }}</span>
              </h5>
              <h5 class="h5-text" v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
                Gender :
                <span class="span-text">{{ agentDetails.gender }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                E-mail:
                <span class="span-text">{{ currentUser.provider.email }}</span>
              </h5>
              <h5 class="h5-text" v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
                Profile Photo :
                <div style="margin-left: 104px; margin-top: -15px">
                  <a :href="agentDetails.profilePhoto" target="_blank">
                    <img :src="agentDetails.profilePhoto" height="90px" width="90px" />
                  </a>
                </div>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h4 class="mx-3" style="color: #727cf5">Action</h4>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Dealer Name :
                <span class="span-text">{{ currentUser.createdBy.name }}</span>
              </h5>
              <h5 class="h5-text">
                Seller Name :
                <span class="span-text">{{
                  currentUser.provider && currentUser.provider.organization
                    ? currentUser.provider.organization.name
                    : ""
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Scope :
                <span class="span-text">{{ currentUser.approvalType }}</span>
              </h5>
              <h5
                class="h5-text"
                v-if="currentUser.approvalType != 'SUBSCRIPTION_ACTIVATION'"
              >
                Category :
                <span class="span-text">{{ currentUser.provider.category }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Created Date :
                <span class="span-text">{{ currentUser.createdAt | formatedate }}</span>
              </h5>
              <h5
                class="h5-text"
                v-if="currentUser.approvalType != 'SUBSCRIPTION_ACTIVATION'"
              >
                Updated Date :
                <span class="span-text">{{ currentUser.updatedAt | formatedate }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr
          v-if="currentUser.approvalType != 'SUBSCRIPTION_ACTIVATION'"
          style="border-top: 1px dashed #727cf5"
          class="mt-2"
        />
        <h4
          class="mx-3"
          v-if="currentUser.approvalType != 'SUBSCRIPTION_ACTIVATION'"
          style="color: #727cf5"
        >
          Address Information
        </h4>
        <b-row v-if="currentUser.approvalType != 'SUBSCRIPTION_ACTIVATION'">
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Street 1 :
                <span class="span-text">{{
                  currentUser.provider.office.address.street1
                }}</span>
              </h5>
              <h5 class="h5-text">
                State:
                <span class="span-text">{{
                  currentUser.provider.office.address.state
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                House No :
                <span class="span-text">{{
                  currentUser.provider.office.address.houseNumber
                }}</span>
              </h5>
              <h5 class="h5-text">
                Country :
                <span class="span-text">{{
                  currentUser.provider.office.address.country
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                City :
                <span class="span-text">{{
                  currentUser.provider.office.address.city
                }}</span>
              </h5>
              <h5 class="h5-text">
                ZIP Code :
                <span class="span-text">{{
                  currentUser.provider.office.address.zip
                }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2" />
        <h4
          v-if="currentUser.approvalType == 'AGENT_ACTIVATION'"
          class="mx-3"
          style="color: #727cf5"
        >
          Other Information
        </h4>
        <b-row v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
          <b-col md="12">
            <div class="mx-3">
              <h5 class="h5-text">
                About Me :
                <span class="span-text">{{ agentDetails.aboutMe }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <!-- Subscription details -->
        <h4
          v-if="currentUser.approvalType == 'SUBSCRIPTION_ACTIVATION'"
          class="mx-3"
          style="color: #727cf5"
        >
          Subscription Details
        </h4>
        <b-row v-if="currentUser.approvalType == 'SUBSCRIPTION_ACTIVATION'">
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Subscription Name :
                <span class="span-text">{{ subscriptionPlanData.planName }}</span>
              </h5>
              <h5 class="h5-text">
                Activation Date :
                <span class="span-text">{{
                  subscriptionData.activationDate | formatedate
                }}</span>
              </h5>
              <h5 class="h5-text">
                Expiry Date :
                <span class="span-text">{{ agentDetails.userName }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Renewal Type :
                <span class="span-text">{{ agentDetails.userName }}</span>
              </h5>
              <h5 class="h5-text">
                Subscription Rate :
                <span class="span-text">
                  {{
                    subscriptionData.pricing ? subscriptionData.pricing.price : ""
                  }}</span
                >
              </h5>
              <h5 class="h5-text">
                Discounted Price :
                <span class="span-text">
                  {{
                    subscriptionData.pricing && subscriptionData.pricing.discount
                      ? subscriptionData.pricing.discount.value
                      : ""
                  }}</span
                >
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Cadence Type :
                <span class="span-text">{{
                  subscriptionData.pricing ? subscriptionData.pricing.cadence : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Payment Type :
                <span class="span-text">{{ subscriptionData.paymentType }}</span>
              </h5>
              <h5 class="h5-text">
                Unit of Measurement :
                <span class="span-text">{{
                  subscriptionData.pricing ? subscriptionData.pricing.uom : ""
                }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <!-- Organization Details Start -->
        <h4
          style="color: #727cf5"
          class="mx-3"
          v-if="currentUser.approvalType == 'PROVIDER_ACTIVATION'"
        >
          Organization Details
        </h4>
        <b-row v-if="currentUser.approvalType == 'PROVIDER_ACTIVATION'">
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Registration No :
                <span class="span-text">{{
                  currentUser.provider.organization
                    ? currentUser.provider.organization.registrationNo
                    : ""
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                GST No :
                <span class="span-text">{{
                  currentUser.provider.organization
                    ? currentUser.provider.organization.gstNo
                    : ""
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                FASSAI No:
                <span class="span-text">{{
                  currentUser.provider.organization
                    ? currentUser.provider.organization.fssciNo
                    : ""
                }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <!-- Agreement Document -->
        <template v-if="currentUser.approvalType == 'PROVIDER_ACTIVATION'">
          <b-button
            size="sm"
            class="mr-2 my -0 main-navigation-button mx-3"
            variant="primary"
            v-b-modal.modal-1
            @click="kycByUser"
          >
            View Agreement Document
          </b-button>
          <b-modal id="modal-1" scrollable size="lg" centered ok-only>
            <b-row v-if="isloading">
              <b-col md="12" class="text-center">
                <h4>Loading....</h4>
              </b-col>
            </b-row>
            <b-row
              class="px-5 py-2"
              v-else-if="
                currentUser && currentUser.provider && currentUser.provider.organization
              "
            >
              <b-col md="8" class="justify-content-center">
                <b-row>
                  <h5 class="h5-text">Logo :</h5>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <a
                      target="_blank"
                      :href="
                        currentUser.provider.organization &&
                        currentUser.provider.organization.logo
                          ? currentUser.provider.organization.logo.url
                          : ''
                      "
                    >
                      <img
                        :src="
                          currentUser.provider.organization &&
                          currentUser.provider.organization.logo
                            ? currentUser.provider.organization.logo.url
                            : ''
                        "
                        height="200px"
                        width="200px"
                      />
                    </a>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col md="12" class="text-center">
                <h4>Data not found</h4>
              </b-col>
            </b-row>
          </b-modal>
        </template>
        <!-- kyc start -->
        <template v-if="currentUser.approvalType == 'AGENT_ACTIVATION'">
          <b-button
            size="sm"
            class="mr-2 my -0 main-navigation-button mx-3"
            variant="primary"
            v-b-modal.modal-1
            @click="kycByUser"
          >
            KYC Details
          </b-button>
          <b-modal id="modal-1" scrollable size="lg" centered ok-only>
            <b-row v-if="isloading">
              <b-col md="12" class="text-center">
                <h4>Loading....</h4>
              </b-col>
            </b-row>
            <b-row
              class="px-5 py-2"
              v-else-if="kycUser && kycUser.documents && kycUser.documents.length"
            >
              <b-col
                md="8"
                class="justify-content-center"
                :key="i"
                v-for="(kyc, i) in kycUser.documents"
              >
                <b-row>
                  <h5 class="h5-text">
                    {{ kyc.category }} :
                    <span class="span-text">{{ kyc.docuementNo }}</span>
                  </h5>
                </b-row>
                <b-row
                  ><h5 class="h5-text">
                    Document Type :
                    <span class="span-text">{{ kyc.category }}</span>
                  </h5></b-row
                >
                <b-row>
                  <h5 class="h5-text">Photo :</h5>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <a target="_blank" :href="kyc.frontSideFilePath">
                      <img :src="kyc.frontSideFilePath" height="200px" width="200px" />
                    </a>
                    <label>Front Side</label>
                  </b-col>
                  <b-col md="6">
                    <a target="_blank" :href="kyc.backSideFilePath">
                      <img :src="kyc.backSideFilePath" height="200px" width="200px" />
                    </a>
                    <label>Back Side</label>
                  </b-col>
                </b-row>
                <hr />
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col md="12" class="text-center">
                <h4>Kyc Data not found</h4>
              </b-col>
            </b-row>
          </b-modal>
        </template>
        <!-- kyc end -->
        <div class="text-center mb-5 mt-2 p-4" v-if="currentUser.status === 'PENDING'">
          <button
            type="button"
            class="btn btn-lg btn-outline-danger mr-3 w-25"
            @click="onReject"
          >
            REJECT
          </button>
          <button
            type="button"
            class="btn btn-lg btn-outline-success ml-3 w-25"
            @click="onApprove"
          >
            APPROVE
          </button>
        </div>
        <div class="text-center mb-5 mt-2" v-else>
          <button
            type="button"
            class="btn btn-lg btn-outline-primary mr-3 w-25"
            :disabled="true"
          >
            {{ currentUser.status }}
          </button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentHeader";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import {
  getSubscriptionById,
  getSubscriptionPlanbyFilter,
} from "@/services/subscription";
import currentUser from "@/mixins/currentUser";

export default {
  name: "ApprovalView",
  components: {
    ComponentHeader,
  },
  data() {
    return {
      isloading: false,
      currentUser: "",
      subscriptionData: undefined,
      subscriptionPlanData: undefined,
    };
  },
  computed: {
    ...mapGetters({
      kycUser: "tenant/GetKycByUser",
      agentDetails: "partner/GetAgentDetails",
    }),
  },
  methods: {
    async agentDetailsforUser() {
      this.isloading = true;
      if (this.currentUser.approvalType == "AGENT_ACTIVATION") {
        const data = await this.$store
          .dispatch("partner/viewAgentDetails", {
            id: this.currentUser.provider.id,
          })
          .then((res) => {});
      }
      if (this.currentUser.approvalType == "SUBSCRIPTION_ACTIVATION") {
        const res = await getSubscriptionById(this.currentUser.subscription.id);
        this.subscriptionData = res.data.response;
        const planRes = await getSubscriptionPlanbyFilter({
          _id: this.subscriptionData.plan,
          first: true,
        });
        this.subscriptionPlanData = planRes.data.response;
      } else {
        this.subscriptionData = undefined;
      }
      this.isloading = false;
    },
    async kycByUser() {
      this.isloading = true;
      const data = await this.$store
        .dispatch("tenant/fetchKYCListByUser", {
          id: this.currentUser.provider.id,
        })
        .then((res) => {});
      this.isloading = false;
    },
    getApprovalsList() {
      this.loading = true;
      let payload = `status=${this.selectedStatus}&dealerId=${
        this.selectedProvider ? this.selectedProvider._id : ""
      }&n=${this.selectedPeriod.value}`;
      this.$store
        .dispatch("partner/getApprovalList", payload)
        .then((data) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onApprove() {
      let payload = {
        id: this.currentUser._id,
        data: {
          history: {
            action: "APPROVED",
            user: {
              id: this.$currentUserData._id,
              userType: this.$currentUserData.category,
            },
            description: "",
          },
        },
      };
      this.$store
        .dispatch("partner/updateApprovalRequest", payload)
        .then((response) => {
          if (response.status === 1) {
            this.currentUser = {};
            this.$swal({
              title: "Success",
              text: "Approval request accepted!",
              type: "success",
            });
            this.$router.push("/approvals");
          }
        })
        .catch((e) => {});
    },
    onReject() {
      this.$swal({
        title: "Reject this request?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Reject it!",
      }).then((result) => {
        if (result.value) {
          let payload = {
            id: this.currentUser._id,
            data: {
              history: {
                action: "REJECTED",
                user: {
                  id: this.$currentUserData._id,
                  userType: this.$currentUserData.category,
                },
                description: "",
              },
            },
          };
          this.$store
            .dispatch("partner/updateApprovalRequest", payload)
            .then((response) => {
              if (response.status === 1) {
                this.currentUser = {};
                this.$swal({
                  title: "Success",
                  text: "Approval request rejected!",
                  type: "success",
                });
                this.$router.push("/approvals");
              }
            })
            .catch((e) => {});
        }
      });
    },
  },
  mounted: async function () {
    this.loading = true;
    this.currentUser = this.$route.params.userData;
    this.kycByUser();
    this.agentDetailsforUser();
    this.loading = false;
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: #727cf5 !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
